import Icon from "@/components/ui/icon";
import { cn } from "@lib/cn";
import type { ReactNode } from "react";

const DialogBase = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return (
    <div
      className={cn(
        "tw-rounded-lg tw-bg-white tw-shadow-lg tw-outline tw-outline-1 tw-outline-blue/5",
        className,
      )}
    >
      {children}
    </div>
  );
};

interface IHeaderProps {
  children?: ReactNode;
  title?: string;
  onClose?: () => void;
  className?: string;
}

const Header = ({ title, onClose, className, children }: IHeaderProps) => {
  return (
    <div
      className={cn(
        "tw-flex tw-h-[72px] tw-items-center tw-justify-between tw-rounded-t-lg tw-border-b tw-border-solid tw-border-blue-100 tw-px-6",
        className,
      )}
    >
      {title && (
        <span className="tw-max-w-[90%] tw-overflow-hidden tw-text-ellipsis tw-text-nowrap tw-font-sans tw-text-base tw-font-semibold tw-text-blue">
          {title}
        </span>
      )}
      {children}
      {onClose && (
        <button
          type="button"
          className="tw-flex tw-cursor-pointer tw-items-center tw-justify-center"
          onClick={onClose}
        >
          <Icon
            icon="ri-close-line"
            className="tw-text-base tw-text-blue-500 tw-transition-colors tw-duration-200 hover:tw-text-blue-800"
          />
        </button>
      )}
    </div>
  );
};

const Content = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return (
    <div className={cn("tw-w-[512px] tw-px-6 tw-pb-14 tw-pt-8", className)}>
      {children}
    </div>
  );
};

const Footer = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return (
    <div
      className={cn(
        "tw-flex tw-items-center tw-justify-end tw-rounded-b-lg tw-border-t tw-border-solid tw-border-blue-100 tw-bg-blue-100/15 tw-px-4 tw-py-[14px]",
        className,
      )}
    >
      {children}
    </div>
  );
};

DialogBase.Header = Header;
DialogBase.Content = Content;
DialogBase.Footer = Footer;

export default DialogBase;
